module.exports = __webpack_public_path__ + "static/media/iStock-1162815759.3fe438d3.jpg";